import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useDuplicateActivitiesToDateMutation } from '../../../../hooks/mutations/useActivityMutation';
import { capitalizeFirstLetter } from '../../../../utils/capitalize';
import ModalBody, { ModalProps } from '../../ModalBody';

interface DuplicateActivitiesModalProps extends ModalProps {
    activityIds: string[];
    initialDate?: Date;
}

const DuplicateActivitiesModal: React.FC<DuplicateActivitiesModalProps> = ({ activityIds, initialDate = new Date(), open, handleClose }) => {
    const { t } = useTranslation();
    const [selectedDate, setSelectedDate] = useState<Date>(initialDate);

    const mutation = useDuplicateActivitiesToDateMutation({
        onSuccess: () => {
            toast.success(capitalizeFirstLetter(t('activitiesDuplicated')));
            handleClose();
        },
    });

    const handleOk = () => {
        mutation.mutate({
            body: { activityIds, targetDate: selectedDate.toISOString() },
        });
    };

    return (
        <ModalBody
            title={t('activities')}
            subtitle={t('duplicate')}
            description={activityIds.length.toString()}
            open={open}
            handleClose={handleClose}
            onSubmit={handleOk}
            submitLoading={mutation.isLoading}
        >
            <div className="fx-c">
                <DateCalendar
                    onChange={(value) => {
                        if (value) setSelectedDate(new Date(value.toISOString()));
                    }}
                    value={dayjs(selectedDate)}
                    displayWeekNumber
                />
            </div>
        </ModalBody>
    );
};

export default DuplicateActivitiesModal;
